import React, { Component } from "react";

export default class StepTwo extends Component {
  state = {
    days: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    time: [
      "9:00 AM",
      "10:00 AM",
      "11:00 AM",
      "12:00 PM",
      "1:00 PM",
      "2:00 PM",
      "3:00 PM",
      "4:00 PM",
      "5:00 PM",
      "6:00 PM",
      "7:00 PM"
    ],
    schedule: [
      {
        day: "Monday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Tuesday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Wednesday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Thursday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Friday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Saturday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      },
      {
        day: "Sunday",
        slot: [{ exist: false, from: "", to: "" }],
        exist: false
      }
    ]
  };

  selectSchedule = e => {
    var schedule = this.state.schedule;
    for (let i = 0; i < schedule.length; i++) {
      if (schedule[i].day === e.target.getAttribute("data-day")) {
        var slots = schedule[i].slot;
        for (let j = 0; j < slots.length; j++) {
          if(j == e.target.getAttribute("data-slot"))
          if (e.target.getAttribute("data-timing") == "start") {
            slots[j].from = e.target.value;
          } else if (e.target.getAttribute("data-timing") == "end") {
            slots[j].to = e.target.value;
          }
        }
      }
    }

    this.setState({schedule:schedule})
  };

  cardSelect = e => {
    var day = e.target.id;

    var schedule = this.state.schedule;

    if (e.target.classList.contains("selected")) {
      e.target.classList.remove("selected");
      for (let i = 0; i < schedule.length; i++) {
        if (schedule[i].day == day) {
          schedule[i].exist = false;
        }
      }
    } else {
      e.target.classList.add("selected");
      for (let i = 0; i < schedule.length; i++) {
        if (schedule[i].day == day) {
          schedule[i].exist = true;
        }
      }
    }

    this.setState({ schedule: schedule });
  };

  addSlot = e => {
    var schedule = this.state.schedule;
    for (let i = 0; i < schedule.length; i++) {
      var slot = schedule[i].slot;
      if (i == e.target.id)
        for (let j = 0; j < slot.length; j++) {
          if (slot[j].exist === false) {
            slot[j].exist = true;
            var obj = { exist: false, from: "", to: "" };
            schedule[i].slot.push(obj);
            break;
          }
        }
    }
    this.setState({ schedule: schedule });
    this.props.selectSchedule(schedule);
  };

  render() {
    return (
      <div className="schedule-div">
        <div className="my-3 text-center">
          <h4>Select your day and time</h4>
          <p className="blockquote-footer">Live classes happening daily.</p>

          <div class="form-group mx-auto">
            <div className="row m-1 mb-2">
              <div className="col-3 px-1">
                <div
                  className="p-2 card card-selector mini selected font-weight-bold"
                  onClick={this.cardSelect}
                >
                  Days
                </div>
              </div>
              <div className="col-3 px-1">
                <div
                  className="p-2 card card-selector mini selected font-weight-bold"
                  onClick={this.cardSelect}
                >
                  Slot 1
                </div>
              </div>
              <div className="col-3 px-1">
                <div
                  className="p-2 card card-selector mini selected font-weight-bold"
                  onClick={this.cardSelect}
                >
                  Slot 2
                </div>
              </div>
              <div className="col-3 px-1">
                <div
                  className="p-2 card card-selector mini selected font-weight-bold"
                  onClick={this.cardSelect}
                >
                  Slot 3
                </div>
              </div>
            </div>
            {/* <label for="exampleFormControlSelect1">Example select</label> */}
            {this.state.days.map((day, key) => {
              return (
                <div>
                  {/* <hr></hr> */}
                  <div key={key} className="row m-1 mb-2">
                    <div className="col-3 px-1">
                      <div
                        id={day}
                        className="p-2 card card-selector mini"
                        onClick={this.cardSelect}
                      >
                        {day}
                      </div>
                    </div>

                    {this.state.schedule.map(schedule => {
                      if (schedule.day == day) {
                        return schedule.slot.length > 0 ? (
                          schedule.slot.map((slot, id) => {
                            if (slot.exist) {
                              return (
                                <div className="col-3 px-1">
                                  <div className="card card-selector minix schedule-duration px-3">
                                    <div className="row d-flex justify-content-around">
                                      <div>
                                        <select
                                          class="form-control p-0"
                                          id={day + id + "start"}
                                          data-day={day}
                                          data-slot={id}
                                          data-timing="start"
                                          onChange={this.selectSchedule}
                                        >
                                          {this.state.time.map(time => {
                                            return <option>{time}</option>;
                                          })}
                                        </select>
                                      </div>
                                      <div className="pt-1">to</div>
                                      <div>
                                        <select
                                          class="form-control p-0"
                                          id={day + id + "end"}
                                          data-day={day}
                                          data-slot={id}
                                          data-timing="end"
                                          onChange={this.selectSchedule}
                                        >
                                          {this.state.time.map(time => {
                                            return <option>{time}</option>;
                                          })}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else {
                              return (
                                <div className="col-3 px-1">
                                  <div className="card card-selector minix schedule-duration p-0">
                                    <div
                                      id={key}
                                      className="py-2"
                                      onClick={this.addSlot}
                                    >
                                      Add Slot
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })
                        ) : (
                          <div className="col-3 px-1">
                            <div className="card card-selector minix schedule-duration p-0">
                              <div
                                id={key}
                                className="py-2"
                                onClick={this.addSlot}
                              >
                                Add Slot
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}

                    {/* <div className="col px-1">
                    {this.state.schedule.map(schedule => {
                      if (schedule.exist && schedule.day == day) {
                        return (
                          <select
                            class="form-control"
                            id="exampleFormControlSelect1"
                            onChange={this.selectSchedule}
                          >
                            {this.state.time.map(time => {
                              return <option>{time}</option>;
                            })}
                          </select>
                        );
                      }
                    })}
                  </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
